import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { BrandService, IBrandDetailModel, IProductCountryDtoModels, IProductMasterStatusesResponse, IProductResolvedData, IProductTypeModel, ProductOptions, ProductOptionService } from "lib-core-shared";

import { CountryService } from "lib-core-shared";

import { combineLatest, Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ProductTypeDtoMapping } from "../containers/product-details/containers/product-info/mappings/product-type-dto-mapping";


  @Injectable()
  export class ProductDetailResolver implements Resolve<IProductResolvedData> {
    productId!: string;
    mapper: ProductTypeDtoMapping;
    constructor(
      private productOptionService: ProductOptionService,
      private brandDetailService: BrandService,
      private countryService: CountryService) {
      this.mapper = new ProductTypeDtoMapping();
    }
  
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IProductResolvedData> {
      const masterProductSatuses$ = !route.params?.id ? 
      this.productOptionService.getProductMasterStatuse().pipe(catchError(() => of({} as IProductMasterStatusesResponse)))
      : this.productOptionService.getProductMasterStatuse(route.params.id).pipe(catchError(() => of({} as IProductMasterStatusesResponse)));
      const productTypes$ = this.productOptionService.getProductType().pipe(map(x => x.types.map(x => {
        x.displayText = x?.translations?.length ? x.translations[0].title: '';
        return x;
      }),catchError(() => of({} as IProductTypeModel))));
      
      
      const options$ = this.productOptionService.getOptions().pipe(catchError(() => of({} as ProductOptions)));
      const brands$ = this.brandDetailService.get('').pipe(map(x => x.brands.map(x => x as IBrandDetailModel)), catchError(() => of({} as IBrandDetailModel[])));
  
      return combineLatest([masterProductSatuses$, options$, productTypes$ , brands$]).pipe(
        map(res => {
          return {
            masterProductSatuses: res[0].statuses,
            componentStatuses: res[1].componentStatuses,
            taxRateCategories: res[1].taxRateCategories,
            discountCategories: res[1].discountCategories,
            countries: res[1].countries,
            productTypes: res[2],
            brands: res[3]
          } as IProductResolvedData;
        }));
    }
  }